import React from 'react';
import { IconProps } from '../types';
const MinecraftBowPulling2: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="3" y="2" width="1" height="1" fill="rgba(255, 255, 255, 255)" />
<rect x="8" y="2" width="1" height="1" fill="rgba(73, 54, 21, 255)" />
<rect x="9" y="2" width="1" height="1" fill="rgba(73, 54, 21, 255)" />
<rect x="10" y="2" width="1" height="1" fill="rgba(73, 54, 21, 255)" />
<rect x="11" y="2" width="1" height="1" fill="rgba(73, 54, 21, 255)" />
<rect x="12" y="2" width="1" height="1" fill="rgba(73, 54, 21, 255)" />
<rect x="13" y="2" width="1" height="1" fill="rgba(73, 54, 21, 255)" />
<rect x="14" y="2" width="1" height="1" fill="rgba(73, 54, 21, 255)" />
<rect x="3" y="3" width="1" height="1" fill="rgba(177, 177, 177, 255)" />
<rect x="4" y="3" width="1" height="1" fill="rgba(216, 216, 216, 255)" />
<rect x="6" y="3" width="1" height="1" fill="rgba(73, 54, 21, 255)" />
<rect x="7" y="3" width="1" height="1" fill="rgba(73, 54, 21, 255)" />
<rect x="8" y="3" width="1" height="1" fill="rgba(137, 103, 39, 255)" />
<rect x="9" y="3" width="1" height="1" fill="rgba(104, 78, 30, 255)" />
<rect x="10" y="3" width="1" height="1" fill="rgba(137, 103, 39, 255)" />
<rect x="11" y="3" width="1" height="1" fill="rgba(137, 103, 39, 255)" />
<rect x="12" y="3" width="1" height="1" fill="rgba(137, 103, 39, 255)" />
<rect x="13" y="3" width="1" height="1" fill="rgba(104, 78, 30, 255)" />
<rect x="14" y="3" width="1" height="1" fill="rgba(137, 103, 39, 255)" />
<rect x="15" y="3" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
<rect x="4" y="4" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
<rect x="5" y="4" width="1" height="1" fill="rgba(137, 103, 39, 255)" />
<rect x="6" y="4" width="1" height="1" fill="rgba(107, 107, 107, 255)" />
<rect x="7" y="4" width="1" height="1" fill="rgba(104, 78, 30, 255)" />
<rect x="8" y="4" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
<rect x="11" y="4" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
<rect x="12" y="4" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
<rect x="13" y="4" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
<rect x="14" y="4" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
<rect x="4" y="5" width="1" height="1" fill="rgba(73, 54, 21, 255)" />
<rect x="5" y="5" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(137, 103, 39, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(107, 107, 107, 255)" />
<rect x="14" y="5" width="1" height="1" fill="rgba(68, 68, 68, 255)" />
<rect x="3" y="6" width="1" height="1" fill="rgba(73, 54, 21, 255)" />
<rect x="4" y="6" width="1" height="1" fill="rgba(107, 107, 107, 255)" />
<rect x="5" y="6" width="1" height="1" fill="rgba(150, 150, 150, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(137, 103, 39, 255)" />
<rect x="14" y="6" width="1" height="1" fill="rgba(68, 68, 68, 255)" />
<rect x="3" y="7" width="1" height="1" fill="rgba(73, 54, 21, 255)" />
<rect x="4" y="7" width="1" height="1" fill="rgba(104, 78, 30, 255)" />
<rect x="5" y="7" width="1" height="1" fill="rgba(107, 107, 107, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(137, 103, 39, 255)" />
<rect x="13" y="7" width="1" height="1" fill="rgba(68, 68, 68, 255)" />
<rect x="2" y="8" width="1" height="1" fill="rgba(73, 54, 21, 255)" />
<rect x="3" y="8" width="1" height="1" fill="rgba(137, 103, 39, 255)" />
<rect x="4" y="8" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(137, 103, 39, 255)" />
<rect x="13" y="8" width="1" height="1" fill="rgba(68, 68, 68, 255)" />
<rect x="2" y="9" width="1" height="1" fill="rgba(73, 54, 21, 255)" />
<rect x="3" y="9" width="1" height="1" fill="rgba(104, 78, 30, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(137, 103, 39, 255)" />
<rect x="13" y="9" width="1" height="1" fill="rgba(68, 68, 68, 255)" />
<rect x="2" y="10" width="1" height="1" fill="rgba(73, 54, 21, 255)" />
<rect x="3" y="10" width="1" height="1" fill="rgba(137, 103, 39, 255)" />
<rect x="4" y="10" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
<rect x="10" y="10" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
<rect x="11" y="10" width="1" height="1" fill="rgba(137, 103, 39, 255)" />
<rect x="13" y="10" width="1" height="1" fill="rgba(68, 68, 68, 255)" />
<rect x="2" y="11" width="1" height="1" fill="rgba(73, 54, 21, 255)" />
<rect x="3" y="11" width="1" height="1" fill="rgba(137, 103, 39, 255)" />
<rect x="4" y="11" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
<rect x="11" y="11" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
<rect x="12" y="11" width="1" height="1" fill="rgba(137, 103, 39, 255)" />
<rect x="2" y="12" width="1" height="1" fill="rgba(73, 54, 21, 255)" />
<rect x="3" y="12" width="1" height="1" fill="rgba(137, 103, 39, 255)" />
<rect x="4" y="12" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
<rect x="11" y="12" width="1" height="1" fill="rgba(68, 68, 68, 255)" />
<rect x="2" y="13" width="1" height="1" fill="rgba(73, 54, 21, 255)" />
<rect x="3" y="13" width="1" height="1" fill="rgba(104, 78, 30, 255)" />
<rect x="4" y="13" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
<rect x="7" y="13" width="1" height="1" fill="rgba(68, 68, 68, 255)" />
<rect x="8" y="13" width="1" height="1" fill="rgba(68, 68, 68, 255)" />
<rect x="9" y="13" width="1" height="1" fill="rgba(68, 68, 68, 255)" />
<rect x="10" y="13" width="1" height="1" fill="rgba(68, 68, 68, 255)" />
<rect x="2" y="14" width="1" height="1" fill="rgba(73, 54, 21, 255)" />
<rect x="3" y="14" width="1" height="1" fill="rgba(137, 103, 39, 255)" />
<rect x="4" y="14" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
<rect x="5" y="14" width="1" height="1" fill="rgba(68, 68, 68, 255)" />
<rect x="6" y="14" width="1" height="1" fill="rgba(68, 68, 68, 255)" />
<rect x="3" y="15" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
</svg>);
export default MinecraftBowPulling2;